export const API_VERSION_HEADER_NAME = 'TW-API-VERSION';
